import {applyMiddleware, createStore} from 'redux'
import {composeWithDevTools} from "redux-devtools-extension"
import rootReducer from "./reducers/rootReducer"
import {loadState, persistState} from "./utils/storePersistence";

const middleware = [];
const devEnhancer = composeWithDevTools(
    applyMiddleware(...middleware)
);

const persistedData = loadState();
export const store = createStore(rootReducer, persistedData, devEnhancer);
store.subscribe(() => persistState(store.getState()));

export const validateStoreFields = () => {
    const state = store.getState();
    const expectedReducers = [];
    expectedReducers.push(Object.hasOwn(state, 'appHeader'));
    expectedReducers.push(Object.hasOwn(state, 'benAdmin'));
    expectedReducers.push(Object.hasOwn(state, 'initialData'));
    expectedReducers.push(Object.hasOwn(state, 'toast'));
    expectedReducers.push(Object.hasOwn(state, 'user'));

    if (expectedReducers.length < Object.keys(state).length) {
        throw Error("Dev time error\nMissing reducer in validExpectedStoreFields function");
    }
}
